import { EditDishes } from '../index'

export default function EditDishesFunc(currDishId: string, currDishStatus: boolean) {
  return EditDishes(currDishId, currDishStatus)
}
